import React, { useState } from 'react';

import { CHEVRON_DOWN_V3, CHEVRON_UP_V3 } from '../../../../constants/images';
import BdsIconButton from '../../Buttons/BdsIconButton/BdsIconButton';
import BdsDivider from '../../Globals/BdsDivider/BdsDivider';

import './ExpansiveCard.scss';

interface ExpansiveCardProps {
  title: string;
  description?: React.ReactNode;
  className?: string;
}

const ExpansiveCard = ({
  title,
  description,
  children,
  className = ''
}: React.PropsWithChildren<ExpansiveCardProps>) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggleCollapse = (shouldCollapse: boolean) => {
    if (!shouldCollapse) {
      return;
    }
    setIsOpen(!isOpen);
  };

  const isDisplay = () => {
    return isOpen ? 'show' : 'hide';
  };

  return (
    <div
      className={`expansive-card ${!isOpen && 'clickable'} ${className}`}
      onClick={() => handleToggleCollapse(!isOpen)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleToggleCollapse(!isOpen);
        }
      }}
    >
      <div className="ec-title-container">
        <div className="ec-title-text">{title}</div>
        <div className="ec-icon">
          <BdsIconButton
            action={() => handleToggleCollapse(true)}
            icon={isOpen ? CHEVRON_UP_V3 : CHEVRON_DOWN_V3}
            size="sm"
            variant="transparent"
          />
        </div>
      </div>
      {description && <div>{description}</div>}
      <div className={`collapsable-section ${isDisplay()}`}>
        <div className="ec-divider">
          <BdsDivider size="s" color="light" />
        </div>
        {children}
      </div>
    </div>
  );
};

export default ExpansiveCard;
